// SKIP_PREFLIGHT_CHECK=true
module.exports = {
  development: {
    site_api: 'http://localhost:9003',
    imgUrl: 'http://localhost:9003/uploads'
  },
  production: {
    site_api: 'https://api2.comkwik.com',
    imgUrl: 'https://api2.comkwik.com/uploads'
  },
};
